const messages = {
  en: {
    link: {
      home: "Home",
    },
    presentation: {
      title: "I'm Iván, Frontend Developer",
      description:
        "I design and implement scalable code, optimization and layouts. I love challenges.",
    },
    about: {
      title: "About me",
      greeting:
        "Hi! My name is Iván, I'm from San Francisco, Córdoba, Argentina.",
      experience_intro:
        "I've been working as a front-end developer for over {years} years (since 2016). Currently, my main focus and specialization is in React and modern front-end development using scalable patterns and clean architecture.",
      past_experience:
        "In the past, I worked extensively with Ionic (Angular) and Vue.js, gaining valuable experience in mobile and web development. I also had the opportunity to be a mentor in the Rooftop community, where I helped others grow in their careers — an experience that strengthened my communication and leadership skills.",
      self_perception:
        "I consider myself a proactive and passionate developer. I'm always looking to improve, keep learning, and do things with the highest possible quality. I enjoy collaborating, proposing ideas, and building products with a strong foundation in good practices, such as component-based architecture and testing.",
      focus_title: "I'm currently focused on:",
      focus_points: [
        "React and React ecosystem (Context, Redux, Hooks)",
        "Building maintainable UIs with scalable architectures",
        "Writing unit tests and applying TDD when possible",
        "Improving performance and usability in web apps",
      ],
    },
    salaries: {
      title: "Formula drag tool",
      description:
        "System for creating Formulas for complex calculations within the salary settlement module. Made in Angular 9. Unit tests with Jasmine. Layout made with Bulma and Angular's event emitter. Made with the native draggable API from HTML5.",
      duration: {
        title: "Date:",
        date: "January 2020 - September 2021",
      },
      position: {
        title: "Role:",
        role: "Frontend & Mobile Developer",
      },
    },
    xubio: {
      title: "Performance",
      description: "Optimization tasks and general improvements:",
      duration: {
        title: "Date:",
        date: "January 2020 - September 2021",
      },
      position: {
        title: "Role:",
        role: "Frontend & Mobile Developer",
      },
      bullet1: "Feature-based architecture.",
      bullet2: "Lazy loading and differential loading optimization.",
      bullet3: "Optimization of loading times with Store implementation.",
      bullet4: "Unit test coverage with Karma and Jasmine.",
      bullet5:
        "Big changes in the system grids to implement alternatives with data grouping, among other powerful features.",
    },
    blockware: {
      title: "Miner rigs' Marketplace",
      description: "React + GraphQl + Apollo + MUI",
      duration: {
        title: "Date:",
        date: "March 2022 - August 2022",
      },
      position: {
        title: "Role:",
        role: "Frontend Developer",
      },
      bullet1:
        "Netlify integration in React project + Scrapping to build an 'API' that serves a data structure to the front end to build functional components.",
      bullet2:
        "Data structures to separate rigs (miners) by model. Totals calcs and dashboard development with data summary and graphs.",
      bullet3:
        "Use of context to handle global currency conversion between BTC and USD and Timezone selection to manage different timezones in the entire app like transactions.",
      bullet4: "Integration tests with Cypress (+50 test cases).",
      bullet5:
        "Main Website with Squarespace CMS. Custom code blocks with js and grid-css to implement custom blocks not provided by the cms.",
    },
    libraries: {
      title: "Progressive migration - Development of own Angular libraries",
      description: "Migration of modules to libraries:",
      duration: {
        title: "Date:",
        date: "January 2020 - September 2021",
      },
      position: {
        title: "Role:",
        role: "Frontend & Mobile Developer",
      },
      bullet1:
        "Disintegration of monolithic legacy system to different SPAs in Angular embedded modules.",
      bullet2:
        "Progressive migration of modules such as Auth to independent libraries that can be installed via NPM.",
      bullet3:
        "Development of independent libraries that can be configured by the client that consumes them.",
    },
    xubioApp: {
      title: "Xubio App",
      description:
        "Mobile application with the capability to make invoices, view balances and much more.",
      duration: {
        title: "Date:",
        date: "January 2020 - September 2021",
      },
      position: {
        title: "Role:",
        role: "Mobile Developer",
      },
      bullet1:
        "Migration from legacy app on Ionic 2 to Ionic 5 with Capacitor and PWA to stablish the bases for the future of the web platform.",
      bullet2:
        "Complete rebuild of deprecated App. Component decoupling and architecture improvements. Full remake. ",
      bullet3: "Coverage with unit tests on Jasmine and Karma.",
      bullet4:
        "Pop & push navigation replaced by Angular Router. Modularized components and lazy loading implementation. Circular dependencies eliminated with software design improvements. ",
    },
    dolar: {
      title: "Dolar Notifier App",
      description:
        "Personal app that sends Push Notifications based on fluctuations in the dollar price in comparison to the Argentine peso. It also offers a price list of different banks and exchange houses ordered by price.",
      bullet1: "Node + Typescript.",
      bullet2: "Dependency injection (Inversify).",
      bullet3:
        "Firebase Cloud Messaging to manage notifications + Firebase RealTime database.",
      bullet4: "Cron that runs the code in charge of updating the prices.",
      bullet5: "Scraping to get updated prices (Cheerio).",
      bullet6: "Ionic 5 + Capacitor",
      bullet7: "FCM to register the token of the devices (Push Notifications).",
      bullet8: "Ads with AdMob.",
      bullet9: "In App Purchases integrated.",
      bullet10: "Price list ordered by selling price.",
    },
    pausaApp: {
      title: "Pausa App",
      description: "Hybrid App development and maintenance in Ionic Framework.",
      duration: {
        title: "Date:",
        date: "December 2016 - January 2020",
      },
      position: {
        title: "Role:",
        role: "Frontend & Mobile Developer",
      },
      bullet1:
        "Integration with Firebase Auth / Realtime Database / Remote Config for A/B Testing.",
      bullet2: "Development of custom audio and video players.",
      bullet3: "Audio download feature.",
      bullet4: "Course progress system.",
      bullet5: "Integration with Chat Premium within the app.",
      bullet6: "Subscription and renewal system.",
      bullet7: "Web animations.",
      bullet8: "Guided tour system for new users.",
      bullet9: "Migration from Ionic 2 to Ionic 4 with Angular 9.",
      bullet10:
        "Unit tests and continuous integration with CircleCI and Github.",
    },
    pausaWeb: {
      title: "Pausa website",
      description:
        "Pause app website made with Angular 9. The Enterprise section implements sliders for mobile devices, contact form and access to the support WhatsApp chat.",
      duration: {
        title: "Date:",
        date: "December 2016 - January 2020",
      },
      position: {
        title: "Role:",
        role: "Frontend & Mobile Developer",
      },
    },
    animaedu: {
      title: "AnimaEdu website",
      description: "Featured tasks:",
      duration: {
        title: "Date:",
        date: "December 2016 - January 2020",
      },
      position: {
        title: "Role:",
        role: "Frontend & Mobile Developer",
      },
      bullet1:
        "Frontend course page (React first release). Different designs for mobile and desktop through breakpoints.",
      bullet2: "Progressive migration to Vue.",
      bullet3:
        "Checkout (purchase page) with an animated card selector integrated to different payment methods. Made in vue.",
      bullet4:
        "Vuex implementation. Refactor in checkout page for store usage.",
      bullet5: "Website optimization using LightHouse.",
      bullet6:
        "Adaptation of the site to a multitenant system. Possibility of customizing colors by manipulating SVG files from Javascript.",
    },
    footer: {
      title: "Get in touch",
      description: "Send me a Message:",
    },
    dxos: {
      title: "DXOS AppsTeam",
      description:
        "I had worked in BraneFrame which is a big ecosystem of apps connected through parties:",
      duration: {
        title: "Date:",
        date: "September 2021 - December 2021",
      },
      position: {
        title: "Role:",
        role: "Frontend Developer",
      },
      bullet1:
        "Converted old apps called 'pads' to their own frames' architecture to be hosted in the registry API and fetch them to easily embed them.",
      bullet2:
        "Created a custom block editor app with ProseMirror extending its functionality to allow the users to drag and drop different blocks of texts and embed other apps inside a document.",
      bullet3: "Refactor and improvements in a Kanban Board App.",
    },
    theSill: {
      title: "The Sill e-commerce",
      description:
        "e-commerce developed in Nuxt.js with Vuex + Nacelle + Sanity (CMS) + Algolia.",
      duration: {
        title: "Date:",
        date: "December 2021 - March 2022",
      },
      position: {
        title: "Role:",
        role: "Frontend Developer",
      },
      bullet1:
        "Implementation of custom filters adapted to the data structure of Shopify products (variants, metafields, tags).",
      bullet2:
        "Implementation of a custom search system with Algolia on the product page.",
      bullet3:
        "Pages with dynamic and re-orderable sections via CMS. Fetching configuration in Nuxt from Sanity to render components dynamically.",
      bullet4:
        "Integration with Shopify via Nacelle to obtain products, prices and checkout.",
    },
    pokerPower: {
      title: "Poker Power",
      description: "Mobile App (React Native + Nestjs + Graphql + Mongodb)",
      duration: {
        title: "Date:",
        date: "August 2022 - February 2023",
      },
      position: {
        title: "Role:",
        role: "Mobile developer",
      },
      app: {
        bullet1: "I developed mini games like survey games and WarGame.",
        bullet2:
          "Implemented tournament's difficulties in the API (entity + mutation) and the APP (UI + queries).",
        bullet3:
          "Refactoring tasks like creating new Mobx modules and decoupling the old ones.",
        bullet4: "Push Notifications + Deeplinks.",
      },
      api: {
        bullet1:
          "Auto-generated tournaments through cronjob in Nestjs + Push notifications with OneSignal.",
        bullet2:
          "Integration with Retool. Tables and metrics. Automated reporting via Slack and Email.",
      },
    },
    clara: {
      title: "Clara",
      description:
        "Product work across Clara's microfrontend ecosystem, focused on scalable React experiences, product enablement, monetization, approvals, settings, and internal tooling.",
      duration: {
        title: "Date:",
        date: "March 2023 - Present",
      },
      position: {
        title: "Role:",
        role: "Frontend Developer",
      },
      bullet1:
        "Built Financial Analyst from scratch, including conversational flows, backend integration, charts, text animations, error states, and request tracking.",
      bullet2:
        "Led Product Enable v3, replacing a legacy product system with a composable package, RFC, documentation, and migration guide.",
      bullet3:
        "Developed monetization flows such as plan and billing, upgrade paths, user limits, banners, and product availability states.",
      bullet4:
        "Implemented Policy Audit Agent flows with feature flags, async states, policy updates, and DOCX uploads.",
      bullet5:
        "Built custom accounting fields and approvals flows for reimbursements, payments, and card transactions.",
      bullet6:
        "Solved monorepo CI/CD blockers, documented shared packages, and supported migrations to the @wenkol namespace.",
      visual: {
        title: "Product impact across fintech workflows",
        products: "Projects",
        stack: "Core stack",
        focus: "Microfrontends",
      },
      chat: {
        title: "Financial Analyst",
        userMessage: "How is spending trending this month?",
        agentMessage1:
          "I detected variations in cards and reimbursements. Preparing summary.",
        agentMessage2:
          "There are opportunities to optimize limits and approvals flows.",
      },
    },
    padelPlus: {
      title: "PadelPlus",
      description:
        "A personal venture into automating padel leagues. This system, built with Ionic and React, handles everything from league and schedule generation to point calculation and leaderboards. Features include customizable image templates for schedules, a template personalization tool, and MercadoPago integration for payments. Available as a web app and on Android.",
      duration: {
        title: "Date:",
        date: "July 2024 - Present",
      },
      position: {
        title: "Role:",
        role: "Architect and Developer",
      },
      bullet1: "Automatic generation of leagues, matchdays, and pairings.",
      bullet2: "Automated point calculation and leaderboard generation.",
      bullet3: "Export match schedules as images with customizable templates.",
      bullet4: "Template customizer (color palette, logo).",
      bullet5: "Payment processing with MercadoPago.",
      bullet6: "Developed with Ionic and React, available on web and Android.",
    },
  },
  es: {
    link: {
      home: "Inicio",
    },
    presentation: {
      title: "Soy Iván, Desarrollador Frontend",
      description:
        "Diseño e implemento código escalable, optimización y maquetado. Me encantan los desafios.",
    },
    about: {
      title: "Sobre mi",
      greeting:
        "¡Hola! Mi nombre es Iván, soy de San Francisco, Córdoba, Argentina.",
      experience_intro:
        "Llevo más de {years} años trabajando como desarrollador front-end (desde 2016). Actualmente, mi principal enfoque y especialización está en React y el desarrollo front-end moderno utilizando patrones escalables y arquitectura limpia.",
      past_experience:
        "En el pasado, trabajé extensamente con Ionic (Angular) y Vue.js, adquiriendo una valiosa experiencia en desarrollo móvil y web. También tuve la oportunidad de ser mentor en la comunidad Rooftop, donde ayudé a otros a crecer en sus carreras — una experiencia que fortaleció mis habilidades de comunicación y liderazgo.",
      self_perception:
        "Me considero un desarrollador proactivo y apasionado. Siempre estoy buscando mejorar, seguir aprendiendo y hacer las cosas con la mayor calidad posible. Disfruto colaborar, proponer ideas y construir productos con una sólida base en buenas prácticas, como la arquitectura basada en componentes y el testing.",
      focus_title: "Actualmente estoy enfocado en:",
      focus_points: [
        "React y el ecosistema de React (Context, Redux, Hooks)",
        "Construir UIs mantenibles con arquitecturas escalables",
        "Escribir tests unitarios y aplicar TDD cuando es posible",
        "Mejorar el rendimiento y la usabilidad en aplicaciones web",
      ],
    },
    salaries: {
      title: "Formula drag tool",
      description:
        "Sistema para creación de Formulas destinadas a calculos complejos dentro del modulo de liquidacion de sueldos. Hecho en Angular 9. Tests unitarios con Jasmine. Maquetado con Bulma y emision de eventos en angular. Hecho con la api draggable nativa de HTML5.",
      duration: {
        title: "Fecha:",
        date: "Enero 2020 - Septiembre 2021",
      },
      position: {
        title: "Posición:",
        role: "Frontend & Mobile Developer",
      },
    },
    blockware: {
      title: "Marketplace de rigs de minería de criptos",
      description: "React + GraphQl + Apollo + MUI",
      duration: {
        title: "Fecha:",
        date: "Marzo 2022 - Agosto 2022",
      },
      position: {
        title: "Posición:",
        role: "Frontend Developer",
      },
      bullet1:
        "Integración con Netlify en proyecto de React + Scrapping para crear una 'API' que sirve una estructura de datos al frontend para crear componentes funcionales.",
      bullet2:
        "Creación y manipulación de estructuras de datos para separar rigs (mineros) por modelo, cálculo de totales y desarrollo de dashboard con resumen de datos y gráficas.",
      bullet3:
        "Uso de context para mantener la conversion global de la moneda seleccionada entre BTC y USD, tambien zona horaria elegida por el usuario como preferencia entre otros estados a nivel global.",
      bullet4: "Tests de integración con Cypress (+50 test cases).",
      bullet5:
        "Desarrollo del Website principal con CMS Squarespace. Bloques de código con js y grid css para implementar bloques complejos que no provee el cms.",
    },
    xubio: {
      title: "Performance",
      description: "Tareas de optimización y mejoras generales:",
      duration: {
        title: "Fecha:",
        date: "Enero 2020 - Septiembre 2021",
      },
      position: {
        title: "Posición:",
        role: "Frontend & Mobile Developer",
      },
      bullet1: "Arquitectura basada en características.",
      bullet2: "Optimización con lazy loading y differential loading.",
      bullet3: "Optimización de tiempos de carga con implementación de Store.",
      bullet4: "Cobertura de tests unitarios con Karma y Jasmine.",
      bullet5:
        "Cambios grandes en las grillas del sistema para implementar alternativas con agrupamiento de datos, entre otras poderosas caracteristicas.",
    },
    libraries: {
      title:
        "Migración progresiva - Desarrollo de librerias propias en Angular",
      description: "Migración de módulos a librerias:",
      duration: {
        title: "Fecha:",
        date: "Enero 2020 - Septiembre 2021",
      },
      position: {
        title: "Posición:",
        role: "Frontend & Mobile Developer",
      },
      bullet1:
        "Desintegración de sistema legacy monolítico a diferentes SPA en Angular embedidos.",
      bullet2:
        "Migración progresiva de módulos como Auth a librerías independientes instalables via NPM.",
      bullet3:
        "Desarrollo de librerias independientes y configurables desde el cliente que las consume.",
    },
    dolar: {
      title: "Dolar Notifier App",
      description:
        "App personal que envía Push Notifications en base a fluctuaciones del dolar respecto al peso argentino. También ofrece un listado de cotizaciones en diferentes bancos y casas de cambio ordenado por precio.",
      bullet1: "Node + Typescript.",
      bullet2: "Inyeccion de dependencias (Inversify).",
      bullet3:
        "Firebase Cloud Messaging para gestionar las notificaciones + RealTime database de Firebase.",
      bullet4:
        "Cron que corre el codigo encargado de actualizar las cotizaciones.",
      bullet5: "Scraping para obtener las cotizaciones actualizadas (Cheerio).",
      bullet6: "Ionic 5 + Capacitor",
      bullet7:
        "FCM para registrar el token de los dispositivos (Push Notifications).",
      bullet8: "Anuncios con AdMob.",
      bullet9: "In App Purchases integrado.",
      bullet10: "Lista de cotizaciones ordenada por precio de venta.",
    },
    xubioApp: {
      title: "Xubio App",
      description:
        "Aplicación móvil con capacidad para facturar, ver balances y mucho mas.",
      duration: {
        title: "Fecha:",
        date: "Enero 2020 - Septiembre 2021",
      },
      position: {
        title: "Posición:",
        role: "Mobile Developer",
      },
      bullet1:
        "Migración de app legacy en Ionic 2 a Ionic 5 con Capacitor y PWA para sentar las bases del futuro de la plataforma web.",
      bullet2:
        "Reconstrucción completa de App deprecada. Puesta en marcha. Desacoplamiento de componentes y mejoras de arquitectura. Reconstrucción al completo.",
      bullet3: "Cobertura con test unitarios en Jasmine y Karma.",
      bullet4:
        "Navegacion pop & push reemplazada por el router de Angular. Componentes modularizados e implementación de lazy loading. Dependencias circulares eliminadas con mejoras en el diseño de software.",
    },
    pausaApp: {
      title: "Pausa App",
      description:
        "Desarrollo y mantenimiento de App híbrida en Ionic Framework.",
      duration: {
        title: "Fecha:",
        date: "Diciembre 2016 - Enero 2020",
      },
      position: {
        title: "Posición:",
        role: "Frontend & Mobile Developer",
      },
      bullet1:
        "Integración con Firebase Auth/Realtime Database/Remote Config para A/B Testing.",
      bullet2: "Desarrollo de reproductores de audio y video personalizados.",
      bullet3: "Descarga de audios.",
      bullet4: "Sistema de progreso de cursos.",
      bullet5: "Integracion con Chat Premium dentro de la app.",
      bullet6: "Sistema de suscripciones y renovacion.",
      bullet7: "Animaciones web.",
      bullet8: "Sistema de Tour guiado para nuevos usuarios.",
      bullet9: "Migracion de Ionic 2 a Ionic 4 con Angular 9.",
      bullet10: "Test unitarios e integración continua con CircleCI y Github.",
    },
    pausaWeb: {
      title: "Sitio web de Pausa",
      description:
        "Sitio web de la app Pausa hecho con Angular 9. La seccion Empresas implementa sliders para dispositivos moviles, formulario de contacto y acceso al chat de WhatsApp de soporte.",
      duration: {
        title: "Fecha:",
        date: "Diciembre 2016 - Enero 2020",
      },
      position: {
        title: "Posición:",
        role: "Frontend & Mobile Developer",
      },
    },
    animaedu: {
      title: "Sitio web de AnimaEdu",
      description: "Tareas destacadas:",
      duration: {
        title: "Fecha:",
        date: "Diciembre 2016 - Enero 2020",
      },
      position: {
        title: "Posición:",
        role: "Frontend & Mobile Developer",
      },
      bullet1:
        "Frontend página de cursos (React primer release). Diferentes diseños para móviles y desktop por medio de breakpoints.",
      bullet2: "Migración progresiva a Vue.",
      bullet3:
        "Checkout (página de compra) con selector de tarjeta animada integrado a diferentes medios de pago. Hecho en vue.",
      bullet4:
        "Implementación de Vuex. Refactor en checkout page para uso del store.",
      bullet5: "Optimización de sitio web mediante LightHouse.",
      bullet6:
        "Adaptación del sitio a un sistema multitenante. Posibilidad de personalización de colores mediante manipulacion de archivos SVG desde Javascript.",
    },
    footer: {
      title: "Contacto",
      description: "Puedes contactarme en:",
    },
    dxos: {
      title: "DXOS AppsTeam",
      description:
        "Trabajé en BraneFrame, un gran ecosistema de apps conectadas mediante parties:",
      duration: {
        title: "Fecha:",
        date: "Septiembre 2021 - Diciembre 2021",
      },
      position: {
        title: "Posición:",
        role: "Frontend Developer",
      },
      bullet1:
        'Convertí aplicaciones antiguas llamadas "pads" a una arquitectura propia de la empresa de "frames" para alojarlas en la registry API y poder obtenerlas para embeberlas facilmente.',
      bullet2:
        "Creé una aplicación de editor de texto en bloques con ProseMirror, extendiendo su funcionalidad, para permitir a los usuarios arrastrar y soltar diferentes bloques de texto e incrustar otras aplicaciones dentro de un documento.",
      bullet3: "Refactorización y mejoras en una App de Tablero Kanban.",
    },
    theSill: {
      title: "The Sill e-commerce",
      description:
        "e-commerce desarrollado en Nuxt.js con Vuex + Nacelle + Sanity (CMS) + Algolia (Motor de busqueda).",
      duration: {
        title: "Fecha:",
        date: "Diciembre 2021 - Marzo 2022",
      },
      position: {
        title: "Posición:",
        role: "Frontend Developer",
      },
      bullet1:
        "Implementación de filtros personalizados adaptados a la estructura de datos de los productos de Shopify (variants, metafields, tags).",
      bullet2:
        "Implementación de un sistema de busqueda personalizado con Algolia en la pagina de productos.",
      bullet3:
        "Paginas con secciones dinamicas y re-ordenables via CMS. Obtención de configuracion en Nuxt desde Sanity para renderizar componentes dinamicamente.",
      bullet4:
        "Integración con Shopify vía Nacelle para la obtención de productos, precios y checkout.",
    },
    pokerPower: {
      title: "Poker Power",
      description:
        "Aplicación móvil (React Native + Nestjs + Graphql + Mongodb)",
      duration: {
        title: "Fecha:",
        date: "Agosto 2022 - Febrero 2023",
      },
      position: {
        title: "Posición:",
        role: "Mobile developer",
      },
      app: {
        bullet1: "Creé minijuegos como survey games y WarGame.",
        bullet2:
          "Implementé dificultades en los torneos en la API (entity + mutation) y la APP (UI + queries).",
        bullet3:
          "Tareas de refactorización como crear nuevos módulos Mobx y desacoplar los antiguos.",
        bullet4: "Push Notifications + Deeplinks.",
      },
      api: {
        bullet1:
          "Generación automática de torneos por medio de cronjob en Nestjs + Notificaciones push con OneSignal.",
        bullet2:
          "Integración con Retool. Tablas y métricas. Reporting automatizado via Slack y Email.",
      },
    },
    clara: {
      title: "Clara",
      description:
        "Trabajo de producto dentro del ecosistema de microfrontends de Clara, enfocado en experiencias React escalables, product enablement, monetización, approvals, settings y tooling interno.",
      duration: {
        title: "Fecha:",
        date: "Marzo 2023 - Actualidad",
      },
      position: {
        title: "Posición:",
        role: "Frontend Developer",
      },
      bullet1:
        "Construí Financial Analyst desde cero, incluyendo flujos conversacionales, integración con backend, gráficas, animaciones de texto, estados de error y tracking de requests.",
      bullet2:
        "Lideré Product Enable v3, reemplazando un sistema legacy de productos con un paquete componible, RFC, documentación y guía de migración.",
      bullet3:
        "Desarrollé flujos de monetización como plan y billing, upgrades, límites de usuarios, banners y estados de disponibilidad de producto.",
      bullet4:
        "Implementé flujos de Policy Audit Agent con feature flags, estados async, actualización de políticas y carga de archivos DOCX.",
      bullet5:
        "Construí campos contables custom y approvals flows para reimbursements, pagos y transacciones con tarjeta.",
      bullet6:
        "Resolví bloqueos de CI/CD en el monorepo, documenté paquetes compartidos y apoyé migraciones al namespace @wenkol.",
      visual: {
        title: "Impacto de producto en flujos fintech",
        products: "Proyectos",
        stack: "Stack principal",
        focus: "Microfrontends",
      },
      chat: {
        title: "Analista Financiero",
        userMessage: "¿Cómo viene el gasto este mes?",
        agentMessage1:
          "Detecté variaciones en tarjetas y reembolsos. Preparando resumen.",
        agentMessage2:
          "Hay oportunidades para optimizar límites y approvals flows.",
      },
    },
    padelPlus: {
      title: "PadelPlus",
      description:
        "Un proyecto personal para la automatización de ligas de pádel. Este sistema, desarrollado con Ionic y React, gestiona desde la generación de ligas y calendarios hasta el cálculo de puntos y tablas de posiciones. Incluye plantillas de imágenes personalizables para los calendarios, un personalizador de plantillas y la integración de MercadoPago para pagos. Disponible como aplicación web y en Android.",
      duration: {
        title: "Fecha:",
        date: "Julio 2024 - Actualidad",
      },
      position: {
        title: "Posición:",
        role: "Arquitecto y Desarrollador",
      },
      bullet1: "Generación automática de ligas, fechas y cruces.",
      bullet2: "Cálculo de puntos y tabla de posiciones automatizada.",
      bullet3:
        "Exportación de calendarios en formato imagen con templates personalizables.",
      bullet4: "Personalizador de templates (paleta de colores, logo).",
      bullet5: "Procesamiento de pagos con MercadoPago.",
      bullet6: "Desarrollado en Ionic y React, disponible en web y Android.",
    },
  },
};

export default messages;
